import PropTypes from 'prop-types';

export default function Badge({ classNames = '', children }) {
	let classes = ['badge'];
	if (classNames) {
		classes = [...classes, ...classNames.split(' ')];
	}
	return <span className={classes.join(' ')}>{children}</span>;
}

Badge.propTypes = {
	children: PropTypes.node,
	classNames: PropTypes.string,
};
